import { normalizeInvitation } from './journeyInvitationModel';

function storageKey(journeyId) {
  return `travel.created-invitations.${String(journeyId)}`;
}

function readRaw(journeyId) {
  try {
    const raw = sessionStorage.getItem(storageKey(journeyId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function readCreatedInvitations(journeyId) {
  return readRaw(journeyId).map(normalizeInvitation);
}

export function rememberCreatedInvitation(journeyId, invitation) {
  const next = normalizeInvitation(invitation);
  const items = readRaw(journeyId).filter((item) => String(item.invitationId) !== next.invitationId);
  items.unshift(next);
  sessionStorage.setItem(storageKey(journeyId), JSON.stringify(items));
  return items.map(normalizeInvitation);
}

export function patchCreatedInvitation(journeyId, invitationId, patch) {
  const id = String(invitationId);
  const items = readRaw(journeyId).map((item) => (
    String(item.invitationId) === id ? { ...item, ...patch } : item
  ));
  sessionStorage.setItem(storageKey(journeyId), JSON.stringify(items));
  return items.map(normalizeInvitation);
}
